import React from "react";
import AdminHeader from "../../../components/admin/AdminHeader";
import { AdminFooter } from "../../../components/admin/AdminFooter";
import AdminPromptsPageEdit from "../../../views/admin/prompts";
import AdminPromptsList from "../../../views/admin/prompts/list";
import AdminSupportRequestPageList from "./list";

const AdminSupportRequestList = () => {
  window.scrollTo(0, 0);

  return (
    <div>
      <AdminHeader />
        <AdminSupportRequestPageList />
      <AdminFooter />
    </div>
  );
};

export default AdminSupportRequestList;
